import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { Router } from '@angular/router';
import { environment } from 'environments/environment.prod';
import { httpservice } from 'http/http';
import { isArray } from 'util';
import { isEmpty } from 'rxjs/operator/isEmpty';
const breadcrumb: any[] = [
  {
    title: 'Home'
    //link: '#'
  },
  {
    title: 'User'
    //link: '#'
  }
];

@Component({
  selector: 'page-user',
  templateUrl: './user.html',
  styleUrls: ['./user.scss']
})

export class PageUser implements OnInit {
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  ctrl: FormControl;
  filtered: any;
  rows = [];
  temp = [];

  users = [];
  key: any;
  fetchCustomer = [];
  loadingIndicator: boolean = true;

  //diaglog
  dialogRef: MdDialogRef<userDialog>;
  selectedOption: string;

  constructor(private httpservice: httpservice, private router: Router, public dialog: MdDialog, private _sharedService: SharedService) {
    this.getUser();
    this.getStartData();
    this._sharedService.emitChange(this.pageTitle);
  }

  getStartData() {
    this.httpservice.fetchget('getJSON_user_all.php?', data => {
      this.rows = data;
      this.temp = data;
      this.loadingIndicator = false;
    });

  }
  getUser() {
    this.httpservice.fetchget('getJSON_user_name.php?', data => {
      this.users = data;
      console.log('------this.users------', this.users);
    })
    this.ctrl = new FormControl();
    this.filtered = this.ctrl.valueChanges
      .startWith(null)
      .map(val => {
        if (isArray(val)) {
          this.key = val[0];
          //this.poCtrl.setValue(val[0]);
        } else {
          this.key = val;
          //this.poCtrl.setValue(val);
        }
        console.log('------val------', this.key);
        return val ? this.users.filter((s) => new RegExp(val, 'gi').test(s.to_fullname)) : this.users;
      });
  }

  disableUser(to_id: string) {
    this.httpservice.fetchget('disableUser.php?id=' + to_id, data => {
      this.getStartData();
    })
  }
  edit(to_id: string) {
    this.router.navigateByUrl('default-layout/user-edit/' + to_id);
  }

  search() {
    this.httpservice.fetchget('getJSON_user_all.php?key=' + this.key, data => {
      this.rows = data;
    })
  }

  ngOnInit() {
  }
  openDialog(to_id: string) {

    let dialogRef = this.dialog.open(userDialog);
    dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if (result === '1') {
        this.disableUser(to_id);
        console.log('---result---', result);
        // alert('postString');
      } else {
        console.log('---result---', result);
        // alert('cancel');
      }

    });
  }
  updateFilter(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function (d) {
      return d.to_user.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.rows = temp;
  }

  updateFilter_(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function (d) {
      return d.to_fullname.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
  }
}
//dialog
@Component({
  selector: 'user-dialog',
  templateUrl: 'dialog.html',
})
export class userDialog {
  Message = 'What would you like to do?';
  constructor(public dialogRef: MdDialogRef<userDialog>) { }
}




// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/user/user.ts